import WrappedRoot from './index';
import WrappedPage from './wrapPageElement';
import createStore from './src/store';

import * as authAction from '@/actions/auth';

export const wrapRootElement = WrappedRoot;
export const wrapPageElement = WrappedPage;

export const onInitialClientRender = () => {
  createStore.store.dispatch(authAction.registerDevice.request());
};
